
import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class ErrorComponent extends Vue {
    protected second = 5

    protected getSecond (): number {
        this.reduceSecond()
        return this.second
    }

    protected async reduceSecond (): Promise<void> {
        const promise = new Promise((resolve) => {
            setTimeout(() => this.second--, 1000)
            if (!this.second) {
                resolve()
            }
        })

        await promise.then(() => this.$router.push({ name: 'accounts' }))
    }
}
